import React from 'react';
import { Button, Group, Text } from '@mantine/core';

type DeliveryUpcomingOrdersProps = {
  // Manifest-wide item total. Null when a member's total could not be
  // calculated: unknown, rather than an understated count.
  summaryItemCount: number | null;
  orderingWindowEndTimeUtc: string;
  vendorId: string;
};

const buildPreviewUrl = ({
  orderingWindowEndTimeUtc,
  vendorId,
}: Pick<DeliveryUpcomingOrdersProps, 'orderingWindowEndTimeUtc' | 'vendorId'>): string => {
  const url = new URL(
    '/select/select_manifests/order_preview',
    import.meta.env.VITE_MY_FOODA_APP_URL
  );
  url.searchParams.set('ordering_window_end_time_utc', orderingWindowEndTimeUtc);
  url.searchParams.set('vendor_id', vendorId);
  return url.href;
};

export const DeliveryUpcomingOrders: React.FC<DeliveryUpcomingOrdersProps> = ({
  summaryItemCount,
  orderingWindowEndTimeUtc,
  vendorId,
}) => {
  return (
    <Group
      justify="space-between"
      p="sm"
      bdrs="md"
      bd="1px solid var(--mantine-color-gray-4)"
    >
      <Group gap={4}>
        <Text>Current Orders</Text>
      </Group>
      <Button
        component="a"
        href={buildPreviewUrl({ orderingWindowEndTimeUtc, vendorId })}
        target="_blank"
        rel="noopener noreferrer"
        variant="outline"
        size="compact-sm"
      >
        Preview
      </Button>
    </Group>
  );
};
